<template>
  <window :winVisible="winVisible" :fullscreen="fullscreen" v-dialpad-drag="{ el: 'im-right-content-header', dom: 'window' }">
    <im-layout>
      <template v-slot:left-sidebar>
        <im-left-sidebar />
      </template>
      <template v-slot:right>
        <im-right />
      </template>
    </im-layout>
    <window :winVisible="imWinCreateTeamVisible" :wrapper-closable="true" :modal-append-to-body="false" width="500px" height="450px" margin="10vh auto 50px" @wrapperClick="wrapperClick">
      <create-team />
    </window>
    <window :winVisible="imTeamMemberAddVisible" :wrapper-closable="true" :modal-append-to-body="false" width="500px" height="450px" margin="10vh auto 50px" @wrapperClick="teamMemberAddWrapperClick">
      <team-member-add />
    </window>
    <window :winVisible="imTeamMemberRemoveVisible" :wrapper-closable="true" :modal-append-to-body="false" width="500px" height="450px" margin="10vh auto 50px" @wrapperClick="teamMemberRemoveWrapperClick">
      <team-member-remove />
    </window>
    <window :winVisible="imConfirmVisible" :wrapper-closable="true" :modal-append-to-body="false" width="280px" height="150px" margin="20vh auto 50px" @wrapperClick="confirmWrapperClick">
      <im-notify />
    </window>
    <window :winVisible="imSetWinVisible" :wrapper-closable="true" :modal-append-to-body="false" width="500px" height="450px" margin="10vh auto 50px" @wrapperClick="setWrapperClick">
      <im-set-ing />
    </window>
  </window>
</template>

<script>
import Window from './Window'
import ImLeftSidebar from './leftSidebar/ImLeftSidebar'
import ImLayout from './ImLayout'
import ImRight from './right/ImRight'
import CreateTeam from './team/create/CreateTeam.vue'
import TeamMemberAdd from './team/member/TeamMemberAdd'
import TeamMemberRemove from './team/member/TeamMemberRemove'
import { mapState, mapActions } from 'vuex'
import ImNotify from './notify/ImNotify'
import ImSetIng from './leftSidebar/ImSetIng'
export default {
  name: 'ImWindow',
  components: {
    ImNotify,
    Window,
    ImLayout,
    ImLeftSidebar,
    ImRight,
    CreateTeam,
    TeamMemberAdd,
    TeamMemberRemove,
    ImSetIng
  },
  props: {
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState({
      winVisible: state => state.imVisible,
      fullscreen: state => state.imFullscreen,
      imWinCreateTeamVisible: state => state.imWinCreateTeamVisible,
      imConfirmVisible: state => state.imConfirm.visible,
      imTeamMemberAddVisible: state => state.imTeamMemberAddVisible,
      imTeamMemberRemoveVisible: state => state.imTeamMemberRemoveVisible,
      imSetWinVisible: state => state.imSetWinVisible
    })
  },
  watch: {
  },
  methods: {
    ...mapActions(['imConfirmReject']),
    wrapperClick () {
      if (this.imWinCreateTeamVisible) this.$store.dispatch('changeImWinCreateTeamVisibleAction', false)
    },
    teamMemberAddWrapperClick () {
      if (this.imTeamMemberAddVisible) this.$store.dispatch('changeImTeamMemberAddVisibleAction', false)
    },
    teamMemberRemoveWrapperClick () {
      if (this.imTeamMemberRemoveVisible) this.$store.dispatch('changeImTeamMemberRemoveVisibleAction', false)
    },
    confirmWrapperClick () {
      this.imConfirmReject()
    },
    setWrapperClick () {
      if (this.imSetWinVisible) this.$store.dispatch('changeImSetWinVisibleAction', false)
    }
  }
}
</script>

<style lang="stylus" scoped>
</style>



// WEBPACK FOOTER //
// src/common/im/ImWindow.vue